import { baseApi } from "utils/axios/baseApi";
import { ASSESSMENT_TEMPLATE_CREATE, ASSESSMENT_TEMPLATE_DELETE, ASSESSMENT_TEMPLATE_LIST, ASSESSMENT_TEMPLATE_TABLE_TYPE_LIST, ASSESSMENT_TEMPLATE_UPDATE, ASSESSMENT_TEMPLATE_VIEW } from "config/apiPaths";

const assessmentTemplateManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getAssessmentTemplateList: builder.query({
      query: ({ page, limit, search, sort }) => ({
        method: "PATCH",
        url: ASSESSMENT_TEMPLATE_LIST,
        data: {
          page,
          limit,
          search,
          sort
        }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assessmentTemplateList']
    }),

    createAssessmentTemplate: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: `${ASSESSMENT_TEMPLATE_CREATE}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentTemplateList']
    }),

    deleteAssessmentTemplate: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${ASSESSMENT_TEMPLATE_DELETE}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentTemplateList']
    }),

    getAssessmentTemplate: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${ASSESSMENT_TEMPLATE_VIEW}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assessmentTemplateDetail']
    }),

    updateAssessmentTemplate: builder.mutation({
      query: ({ body, id }) => ({
        method: "PATCH",
        url: `${ASSESSMENT_TEMPLATE_UPDATE}/${id}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assessmentTemplateList', 'assessmentTemplateDetail']
    }),

    getAssessmentTemplateTableTypeList: builder.query({
      query: ({ page, limit, search }) => ({
        method: "PATCH",
        url: ASSESSMENT_TEMPLATE_TABLE_TYPE_LIST,
        data: {
          page,
          limit,
          search
        }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assessmentTemplateTableTypeList']
    }),
  })
})

export const {
  useGetAssessmentTemplateListQuery,
  useCreateAssessmentTemplateMutation,
  useDeleteAssessmentTemplateMutation,
  useGetAssessmentTemplateQuery,
  useUpdateAssessmentTemplateMutation,
  useGetAssessmentTemplateTableTypeListQuery,
} = assessmentTemplateManagementApi